
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-up': {
    width: 13.7,
    height: 16.5,
    viewBox: '0 0 13.7 16.5',
    data: '<path pid="0" d="M12.449 7.65l-4.3-4.3-.1-.1c-.7-.6-1.8-.6-2.4.1l-4.4 4.4c-.3.3-.3.7 0 1 .1.1.3.2.5.2s.4-.1.5-.2l3.8-3.8v10.8c0 .4.3.8.8.8s.7-.3.7-.8V4.95l3.8 3.8c.3.3.8.3 1.1 0s.3-.8 0-1.1zm.5-6.2H.749c-.4 0-.7-.3-.7-.7s.3-.7.8-.7h12.2c.4 0 .8.3.8.7s-.5.7-.9.7z"/>'
  }
})
